import React from 'react';

export type ViewLayoutMode = 'list' | 'grid';

interface ViewLayoutToggleProps {
  mode: ViewLayoutMode;
  onChange: (mode: ViewLayoutMode) => void;
  className?: string;
}

export const ViewLayoutToggle: React.FC<ViewLayoutToggleProps> = ({ mode, onChange, className = '' }) => (
  <div
    className={`inline-flex rounded-xl border border-border bg-surface-muted/60 p-0.5 ${className}`}
    role="group"
    aria-label="List or grid layout"
  >
    <button
      type="button"
      onClick={() => onChange('list')}
      className={`rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${
        mode === 'list' ? 'bg-surface text-fg shadow-sm' : 'text-fg-muted hover:text-fg'
      }`}
    >
      List
    </button>
    <button
      type="button"
      onClick={() => onChange('grid')}
      className={`rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${
        mode === 'grid' ? 'bg-surface text-fg shadow-sm' : 'text-fg-muted hover:text-fg'
      }`}
    >
      Grid
    </button>
  </div>
);
